import { Component, OnInit, ViewChild } from '@angular/core';
//import { MatButtonModule } from '@angular/material/button';
//import { MatIconModule } from '@angular/material/icon';
//import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { SideBarService } from '../../services/sidebar.service';
import { User } from '../../models/user';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { UserLoginData } from '../../models/user-login-data';

@Component({
  selector: 'app-menu-user',
  standalone: false,
  templateUrl: './menu-user.component.html',
  styleUrl: './menu-user.component.css'
})
export class MenuUserComponent implements OnInit {

  @ViewChild(MatMenu) public menuUser: MatMenu = new MatMenu();

  @ViewChild('menuTrigger') matMenuTrigger: MatMenuTrigger =  new MatMenuTrigger();

  userData: UserLoginData; // User;
  groupsDescription: [] = [];
  
  ngOnInit() {
    this.sideBarService.changeMenuUser.subscribe(isOpen => {
     this.matMenuTrigger.openMenu();
     //this.menuUser.parentMenu.
    });
  }

  constructor(private authService: AuthService,
              private router: Router,
              private sideBarService: SideBarService,
              private authStore: Store<{authRdc: any}>
            ){ 
    this.userData = new UserLoginData(); //User();
    this.authStore.pipe(
      select('authRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        user: state.user,
        groupsDescription: state.groupsDescription
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ user, groupsDescription }) => {
    this.userData = JSON.parse(JSON.stringify(user));
    this.groupsDescription = JSON.parse(JSON.stringify(groupsDescription));
    });
  }

  handlerLogout(){
    this.authService.logout();
    this.router.navigate(['/login'])
  }
}